import { Language, useLanguage } from "../contexts/LanguageContext";
import type { BaseComponentProps } from "./base/BaseComponent";

const LABELS: Record<Language, string> = {
  en: "EN",
  ru: "RU",
  ja: "日本語",
};

// Order of languages for cycling
const LANGUAGE_ORDER: Language[] = ["en", "ru", "ja"];

export const LanguageSwitcher = ({ className }: BaseComponentProps) => {
  const { language, setLanguage } = useLanguage();

  const cycleLanguage = () => {
    const currentIndex = LANGUAGE_ORDER.indexOf(language);
    const nextIndex = (currentIndex + 1) % LANGUAGE_ORDER.length;
    const nextLanguage = LANGUAGE_ORDER[nextIndex] ?? "en";
    setLanguage(nextLanguage);
  };

  return (
    <button
      type="button"
      onClick={cycleLanguage}
      className={`bg-transparent border-0 shadow-none text-sm focus:outline-none font-medium no-underline p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-900 transition-colors ${className ?? ""}`.trim()}
      aria-label={`Current language: ${LABELS[language]}. Click to change.`}
    >
      {LABELS[language]}
    </button>
  );
};
